import { __decorate } from 'tslib';
import { Input, HostListener, Component, ViewEncapsulation, NgModule } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { CommonModule } from '@angular/common';

var NgGoTopButtonComponent = /** @class */ (function () {
    /**
     * Component for adding a go-to-top button to scrollable browser content
     */
    function NgGoTopButtonComponent() {
        this.animationState = 'out';
        this.timerID = null;
        /**
         * Go top button will appear when user scrolls Y to this position
         */
        this.scrollDistance = 200;
        /**
         * User styles config object
         */
        this.styles = {};
        /**
         * Classes to be applied to the button
         */
        this.classNames = 'go-top-button';
        /**
         * If true scrolling to top will be animated
         */
        this.animate = false;
        /**
         * Animated scrolling speed
         */
        this.speed = 80;
        /**
         * Acceleration coefficient, added to speed when using animated scroll
         */
        this.acceleration = 0;
        /**
         * Button tabIndex HTML attribute
         */
        this.tabIndex = 0;
    }
    NgGoTopButtonComponent.prototype.ngOnInit = function () {
        this.validateInputs();
    };
    NgGoTopButtonComponent.prototype.validateInputs = function () {
        var errorMessagePrefix = 'GoTopButton component input validation error: ';
        if (this.scrollDistance < 0) {
            throw Error(errorMessagePrefix + '\'scrollDistance\' parameter must be greater or equal to 0');
        }
        if (this.speed < 1) {
            throw Error(errorMessagePrefix + '\'speed\' parameter must be a positive number');
        }
        if (this.acceleration < 0) {
            throw Error(errorMessagePrefix + '\'acceleration\' parameter must be greater or equal to 0');
        }
        if (typeof this.classNames !== 'string') {
            throw Error(errorMessagePrefix + '\'classNames\' parameter must be a string like \'class1 class2 class3\'');
        }
    };
    /**
     * Listens to window scroll and animates the button
     */
    NgGoTopButtonComponent.prototype.onWindowScroll = function () {
        if (this.isBrowser()) {
            this.animationState = this.getCurrentScrollTop() > this.scrollDistance ? 'in' : 'out';
        }
    };
    /**
     * Scrolls window to top
     */
    NgGoTopButtonComponent.prototype.scrollTop = function (event) {
        if (!this.isBrowser()) {
            return;
        }
        event.preventDefault();
        if (this.animate) {
            this.animateScrollTop();
        }
        else {
            window.scrollTo(0, 0);
        }
    };
    /**
     * Performs the animated scroll to top
     */
    NgGoTopButtonComponent.prototype.animateScrollTop = function () {
        var _this = this;
        if (this.timerID !== null) {
            return;
        }
        var initialSpeed = this.speed;
        this.timerID = setInterval(function () {
            window.scrollBy(0, -initialSpeed);
            initialSpeed = initialSpeed + _this.acceleration;
            if (_this.getCurrentScrollTop() === 0) {
                clearInterval(_this.timerID);
                _this.timerID = null;
            }
        }, 15);
    };
    /**
     * Get current Y scroll position
     */
    NgGoTopButtonComponent.prototype.getCurrentScrollTop = function () {
        if (typeof window.scrollY !== 'undefined' && window.scrollY >= 0) {
            return window.scrollY;
        }
        if (typeof window.pageYOffset !== 'undefined' && window.pageYOffset >= 0) {
            return window.pageYOffset;
        }
        if (typeof document.body.scrollTop !== 'undefined' && document.body.scrollTop >= 0) {
            return document.body.scrollTop;
        }
        if (typeof document.documentElement.scrollTop !== 'undefined' && document.documentElement.scrollTop >= 0) {
            return document.documentElement.scrollTop;
        }
        return 0;
    };
    /**
     * Get button style
     */
    NgGoTopButtonComponent.prototype.getStyle = function () {
        return this.styles || {};
    };
    /**
     * This check will prevent 'window' logic to be executed
     * while executing the server rendering
     */
    NgGoTopButtonComponent.prototype.isBrowser = function () {
        return typeof (window) !== 'undefined';
    };
    __decorate([
        Input()
    ], NgGoTopButtonComponent.prototype, "scrollDistance", void 0);
    __decorate([
        Input()
    ], NgGoTopButtonComponent.prototype, "styles", void 0);
    __decorate([
        Input()
    ], NgGoTopButtonComponent.prototype, "classNames", void 0);
    __decorate([
        Input()
    ], NgGoTopButtonComponent.prototype, "animate", void 0);
    __decorate([
        Input()
    ], NgGoTopButtonComponent.prototype, "speed", void 0);
    __decorate([
        Input()
    ], NgGoTopButtonComponent.prototype, "acceleration", void 0);
    __decorate([
        Input()
    ], NgGoTopButtonComponent.prototype, "tabIndex", void 0);
    __decorate([
        HostListener('window:scroll', [])
    ], NgGoTopButtonComponent.prototype, "onWindowScroll", null);
    NgGoTopButtonComponent = __decorate([
        Component({
            selector: 'ng-go-top-button',
            template: "\n    <button type=\"button\" aria-label=\"go to top of page\"\n            [tabIndex]=\"tabIndex\"\n            [@appearInOut]=\"animationState\"\n            (click)=\"scrollTop($event)\"\n            [ngStyle]=\"getStyle()\"\n            [ngClass]=\"classNames\">\n      <ng-content></ng-content>\n    </button>",
            encapsulation: ViewEncapsulation.None,
            animations: [
                trigger('appearInOut', [
                    state('in', style({
                        opacity: '0.85'
                    })),
                    state('out', style({
                        opacity: '0'
                    })),
                    transition('in => out', animate('400ms ease-in-out')),
                    transition('out => in', animate('400ms ease-in-out'))
                ]),
            ],
            styles: [".go-top-button {\n      position: fixed;\n      cursor: pointer;\n      outline: none;\n      top: 50%;\n      bottom: 50%;\n      right: 0;\n      width: 35px;\n      height: 35px;\n      line-height: 35px;\n      text-decoration: none;\n      color: #ffffff;\n      background: rgba(0, 0, 0, 0.3);\n      border: none;\n      border-radius: 3px 0 0 3px;\n    }\n\n    .go-top-button:hover, .go-top-button:focus {\n      background-color: rgba(0, 0, 0, 0.6);\n      text-decoration: none;\n      color: white;\n    }"]
        })
        /**
         * Component for adding a go-to-top button to scrollable browser content
         */
    ], NgGoTopButtonComponent);
    return NgGoTopButtonComponent;
}());

var GoTopButtonModule = /** @class */ (function () {
    function GoTopButtonModule() {
    }
    GoTopButtonModule = __decorate([
        NgModule({
            imports: [CommonModule],
            declarations: [NgGoTopButtonComponent],
            exports: [NgGoTopButtonComponent]
        })
    ], GoTopButtonModule);
    return GoTopButtonModule;
}());

/*
 * Public API Surface of ng-go-top-button
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GoTopButtonModule, NgGoTopButtonComponent };
//# sourceMappingURL=ng-go-top-button.js.map
